import React from 'react';

const EnrichedVat = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">VAT Summary (Input vs Output)</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Output VAT</small>
                            <strong className="text-primary">{data.output_vat?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Input VAT</small>
                            <strong className="text-success">{data.input_vat?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Net VAT</small>
                            <strong className={data.net_vat >= 0 ? 'text-danger' : 'text-success'}>
                                {data.net_vat?.toLocaleString(undefined, { minimumFractionDigits: 3 })}
                            </strong>
                        </div>
                    </div>
                </div>
                {(data.output_by_location?.length > 0 || data.input_by_location?.length > 0) && (
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Location</th>
                                    <th className="text-end">Output VAT</th>
                                    <th className="text-end">Input VAT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.output_by_location?.map((loc, i) => {
                                    const inputLoc = data.input_by_location?.find(l => l.location_id === loc.location_id);
                                    return (
                                        <tr key={i}>
                                            <td>{loc.location_name}</td>
                                            <td className="text-end">{loc.vat_amount?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{inputLoc?.vat_amount?.toLocaleString(undefined, { minimumFractionDigits: 3 }) || '0.000'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EnrichedVat;
